// Copyright (c) 2017 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetFilters = () => getDefaultState().searchFilters;

const updateListFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.filterBy
        }
    });

const updateListSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.sortBy
        }
    });

const updateListSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.sortDirection
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.RESET_MASS_LABOR_RATE_REQUEST_FILTERS]: resetFilters,
        [actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTER_BY]: updateListFilterBy,
        [actions.UPDATE_MASS_LABOR_RATE_REQUEST_SORT_BY]: updateListSortBy,
        [actions.UPDATE_MASS_LABOR_RATE_REQUEST_SORT_DIRECTION]: updateListSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/reducers/search-filters.js